import { useEffect, useState } from 'react';
import {
    CONFIG_KEYS_UPDATED_EVENT,
    getConfigKeyContentFromDict,
    getConfigKeys,
} from '@/services/config/config-keys-store';

const CONFIG_SETTING_LOGO_HEADER = 'config_setting_logo_header';
const CONFIG_LOGO_HEADER = 'config_logo_header';

function resolveLogoHeaderSrc(raw?: string): string {
    const value = (raw ?? '').trim();
    if (!value) return '';
    if (
        value.startsWith('data:')
        || value.startsWith('blob:')
        || value.startsWith('http://')
        || value.startsWith('https://')
        || value.startsWith('/')
    ) {
        return value;
    }
    return `data:image/png;base64,${value}`;
}

/** Logo khách hàng từ bsc.config.keys.<tenant> khi config_setting_logo_header = true. */
export function useCustomerLogoHeader(tenantID?: string | null): string {
    const [src, setSrc] = useState('');

    useEffect(() => {
        let cancelled = false;
        if (!tenantID) {
            setSrc('');
            return;
        }

        const load = () => {
            void getConfigKeys(false, tenantID)
                .then((dict) => {
                    if (cancelled) return;
                    const enabled =
                        getConfigKeyContentFromDict(dict, CONFIG_SETTING_LOGO_HEADER, 'false') === 'true';
                    const raw = getConfigKeyContentFromDict(dict, CONFIG_LOGO_HEADER, '') ?? '';
                    setSrc(enabled ? resolveLogoHeaderSrc(raw) : '');
                })
                .catch(() => {
                    if (!cancelled) setSrc('');
                });
        };

        load();

        const onConfigKeysUpdated = (event: Event) => {
            const detailTenant = (event as CustomEvent<{ tenantId?: string }>).detail?.tenantId;
            if (!detailTenant || detailTenant === tenantID) {
                load();
            }
        };
        window.addEventListener(CONFIG_KEYS_UPDATED_EVENT, onConfigKeysUpdated);

        return () => {
            cancelled = true;
            window.removeEventListener(CONFIG_KEYS_UPDATED_EVENT, onConfigKeysUpdated);
        };
    }, [tenantID]);

    return src;
}
